import { render, staticRenderFns } from "./soldOrder.vue?vue&type=template&id=3fd204de&"
import script from "./soldOrder.vue?vue&type=script&lang=js&"
export * from "./soldOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports